export const USERNAME_REGEXP: RegExp = new RegExp(
  '^(?!.*\\.\\.)(?!.*\\.$)\\w[\\w.]{1,29}$'
);
export const REEL_URL_REGEXP: RegExp = new RegExp(
  '^((http(s)?://)?(www\\.)?instagram\\.com/reel/.*)$'
);
export const POST_URL_REGEXP: RegExp = new RegExp(
  '^((http(s)?://)?(www\\.)?instagram\\.com/p/.*)$'
);
